module.exports = __webpack_public_path__ + "static/people_img8-df053d7c96db29d4ce5b3c003d05aa5a.png";